export default "__VITE_ASSET__C0dzgB2z__"